import script from "./pingan-offline-page.vue?vue&type=script&lang=ts&setup=true"
export * from "./pingan-offline-page.vue?vue&type=script&lang=ts&setup=true"

import "./pingan-offline-page.vue?vue&type=style&index=0&id=aea66b92&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/qiyexinxi_app-after-sales_prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aea66b92"]])

export default __exports__